
export const getWfPhasesBgColor = (phase) => {
    switch (phase) {
        case "Closed":
            return "default text-white";
        case "Review":
            return "yellow text-dark";
        case "Application":
            return "primary text-white";
        case "Pending":
            return "info text-dark";
        case "Approved":
            return "success text-white";
        case "Denied":
            return "danger text-white";
        case "Withdrawn":
            return "warning text-white";
    }
}

export const getWfPhasesColor = (phase) => {
    switch (phase) {
        case "Closed":
            return "btn-default";
        case "Review":
            return "btn-wf2-default";
        case "Onboarding":
            return "btn-wf2-default";
        case "Application":
            return "btn-primary";
        case "Pending":
            return "btn-info";
        case "Approved":
            return "btn-wf3-default";
        case "Denied":
            return "btn-wf4-default";
        case "Withdrawn":
            return "btn-warning";
        case "Compliance":
            return "btn-wf5-default";
        case "Time Log":
            return "btn-wf6-default";
        case "Invoice":
            return "btn-wf6-default";
        default:
            return "btn-wf-default";
    }
}

export const getFieldData = (aWorkfinityApp, attribue, filedName) => {
    if (aWorkfinityApp === undefined) return "";
    const appEntity = JSON.parse(aWorkfinityApp);
    const appShortName = Object.keys(appEntity)[1];
    const aWorkfinityAppEntity = appEntity[appShortName];
    const obj = aWorkfinityAppEntity[attribue];
    if (!obj) return "";
    if (!obj["@" + filedName]) return "";
    return obj["@" + filedName];
};

export const getFormatedNumber = (number) => {
    if (!number) return;
    return number?.slice(0, 3) + "-" + number?.slice(3, 6) + "-" + number?.slice(6)
}

export const formatSSNNumber = (digits) => {
    const match = digits.match(/^(\d{0,3})(\d{0,2})(\d{0,4})$/);
    if (!match) return '';
    const [, part1, part2, part3] = match;
    let result = '';
    if (part1) result += part1;
    if (part2) result += '-' + part2;
    if (part3) result += '-' + part3;
    return result;
}

export const formatPhoneNumber = (digits) => {
    const match = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/);
    if (!match) return '';
    const [, area, prefix, line] = match;
    let result = '';
    if (area) result += area;
    if (prefix) result += '-' + prefix;
    if (line) result += '-' + line;
    return result;
}

export const getAddressGroup = () => {
    const group = ["apistatecountycity",
        "apistatecounty",
        "apicountrystate",
        "apiuscountycity",
        "apiusstatecounty",
        "apicountrystatecountycity"];
    return group;
}

export const getAllYears = () => {
    const years = [];
    for (let index = 1; index < 36; index++) {
        const element = { id: index, name: 2022 + index };
        years.push(element);
    }
    return years;
}

export const getMonthName = (num) => {
    switch (num) {
        case 1:
            return "January";
        case 2:
            return "February";
        case 3:
            return "March";
        case 4:
            return "April";
        case 5:
            return "May";
        case 6:
            return "June";
        case 7:
            return "July";
        case 8:
            return "Auguest";
        case 9:
            return "September";
        case 10:
            return "October";
        case 11:
            return "November";
        case 12:
            return "December";
        default:
            return "";
    }
}

export const getAllMonths = () => {
    const months = [
        { id: 1, name: "January" },
        { id: 2, name: "February" },
        { id: 3, name: "March" },
        { id: 4, name: "April" },
        { id: 5, name: "May" },
        { id: 6, name: "June" },
        { id: 7, name: "July" },
        { id: 8, name: "August" },
        { id: 9, name: "September" },
        { id: 10, name: "October" },
        { id: 11, name: "November" },
        { id: 12, name: "December" },
    ];
    return months;
}

export const getTotalHours = (hrs) => {
    if (!hrs) return 0;
    const wt = JSON.parse(hrs);
    let totalHours = 0;
    let totalMinutes = 0;
    let totalDays = 0;
    wt.filter((x) => x.title !== null).map((t) => {
        const hrs = t.title.toString().split(".");
        totalHours += parseInt(hrs[0]);
        totalDays += 1;
        if (hrs.length > 1) {
            totalMinutes += parseInt(hrs[1]);
        }
    });
    totalHours += parseInt(totalMinutes / 60);
    return totalHours + "." + (totalMinutes % 60).toString();
};

export const getTotalDays = (hrs) => {
    if (!hrs) return 0;
    const wt = JSON.parse(hrs);
    const days = wt.filter((x) => x.title !== null && x.type !== "m").length;
    if (days === 0) {
        const totalDays = wt.filter((x) => x.title !== null && x.type === "m");
        if (totalDays.length > 0) {
            return totalDays[0].days === undefined ? 0 : totalDays[0].days;
        }
    }
    return days;
};

export const getMonthLastDay = (d) => {
    const dt = new Date(d);
    return new Date(dt.getFullYear(), dt.getMonth() + 1, 0);
};

export const getDropdownCodemanager = async (attribute, attObject) => {
    //const { data: items } = await http.get(config.GetDataTypeCodemanager + attribute.toLowerCase() + "&att=" + attObject);
    return [];//items;
}

export const getSubformDatatypes = async (attribute, attObject) => {
    //const { data } = await http.get(config.GetDataType + attribute + "&attName=" + attObject);
    return [];//data;
}

export const getApplicationData = (appData) => {
    if (!appData) return;
    const data = {};
    const aWorkfinityApp = JSON.parse(appData);
    const appShortName = Object.keys(aWorkfinityApp)[1];
    const aWorkfinityAppEntity = aWorkfinityApp[appShortName];
    Object.keys(aWorkfinityAppEntity).forEach(function (keyValue) {
        if (
            keyValue !== "@xmlns:xsd" &&
            keyValue !== "@xmlns:xsi" &&
            keyValue !== "EntityId"
        ) {
            Object.keys(aWorkfinityAppEntity[keyValue]).forEach(function (
                keyValue1
            ) {
                if (keyValue1 !== "EntityId") {
                    var item = aWorkfinityAppEntity[keyValue][keyValue1];
                    if (typeof item === "object") {
                        if (Array.isArray(item))
                            data[keyValue + "." + keyValue1.replace("@", "")] = item;
                        else
                            data[keyValue + "." + keyValue1.replace("@", "")] = [item];
                    } else {
                        data[keyValue + "." + keyValue1.replace("@", "")] = item;
                    }
                }
            });
        }
    });
    const obj = { data, aWorkfinityApp, appShortName, aWorkfinityAppEntity }
    return obj;
}